import invariant from 'tiny-invariant'

import { useSelfAssessmentWizard } from '@/src/domains/self-assessments/components/SelfAssessmentWizard/SelfAssessmentWizard.context'

export const useSelfAssessmentWizardQuestionForm = () => {
  const { definition, questionIndex } = useSelfAssessmentWizard()

  const question = definition.questions[questionIndex]

  invariant(question, 'Self-assessment question is not configured')

  return {
    question,
    questionIndex,
  }
}
